import { mainAxios } from "libs/axios";

/**send mail props type */
interface sendMailProps {
  platformCode: string;
  senderName: string;
  emailReceiveResult: string;
  subject: string;
  content: string;
}

export const sendMailApi = (payload: sendMailProps) => {
  return mainAxios.request({
    methodType: "POST",
    url: `/request-contact/send-mail`,
    payload: payload,
    // requiresToken: true,
    config: {
      headers: {
        contentType: "application/json",
      },
    },
  });
};

/**list news props type */

interface listNewsProps {
  year: number;
  page: number;
  size: number;
}

export const listNewsApi = (payload: listNewsProps) => {
  return mainAxios.request({
    methodType: "GET",
    url: `/news-for-company/news`,
    params: payload,
    // requiresToken: true,
    config: {
      headers: {
        contentType: "application/json",
      },
    },
  });
};

export const CategoryNewsApi = () => {
  return mainAxios.request({
    methodType: "GET",
    url: `/news-for-company/list-year`,
    // requiresToken: true,
    config: {
      headers: {
        contentType: "application/json",
      },
    },
  });
};
